import {Component, OnInit, ViewChild} from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import {BehaviorSubject} from 'rxjs';
import {StateLifeCycle} from '../../../../Models/enum/stateLifeCycle';
import {BpAdministrationService} from '../../../../services/bp-administration.service';
import {DateTimeService} from '../../../../services/date-time.service';
import {PaginationInstance} from 'ngx-pagination';
import {tap} from 'rxjs/operators';
import {WebClientConfigurationService} from '../../../../services/configuration/web-client-configuration.service';
import {AdminService} from '../../../../services/admin.service';
import {GenericModalService} from '../../../../services/generic-modal.service';
import {QueueActionModalComponent} from './queue-action-modal/queue-action-modal.component';
import {HumanInteractionService} from '../../../../services/human-interaction.service';
import {BusinessProcessService} from '../../../../services/business-process.service';
import {QueueShiftModalComponent} from './queue-shift-modal/queue-shift-modal.component';

@Component({
  selector: 'app-business-process-queue-manager',
  templateUrl: './business-process-queue-manager.component.html',
  styleUrls: ['./business-process-queue-manager.component.css']
})
export class BusinessProcessQueueManagerComponent implements OnInit {

  @ViewChild('bpQueueManagerTabs', { static: false }) bpQueueManagerTabs: TabsetComponent;
  loadingList = false;
  loadingCustomList = false;
  customSearch = false;
  pageIndex = 1;
  p = 1;
  pageConfig;
  filterQueue;
  bpQueueManagerList = [];
  customQueueConfigList = [];
  resultSearchCustomQueueConfig = [];

  config: PaginationInstance;
  disableRegularAllocationBtn;
  disableCustomAllocationBtn;
  hasExecuteRight = false;
  hasGlobalReader = false;
  executedRight = false;
  executedGlobalReader = false;
  isOnInit = true;
  rights = { executeRight: 32, globalReader: 2048 };
  menuItem = 31;
  isMenuEnabled = false;
  lastCustomFilter;
  customErrorMessage = '';
  errorMessage = '';

  pleaseWait = false;

  constructor(private bpAdmin: BpAdministrationService, private dateTimeService: DateTimeService, private modalService: GenericModalService,
              private webClientConfig: WebClientConfigurationService, private bpService: BusinessProcessService,
              private humanInteractionService: HumanInteractionService, private adminService: AdminService) { }

  ngOnInit() {
    this.getRights();
    this.getPageConfig();
    this.getCustomQueueConfig();
    this.disableRegularAllocationBtn = true;
    this.disableCustomAllocationBtn = true;
    this.search(this.getDefaultFilter());
  }

  search(event) {
    this.loadingList = true;
    this.getPagedQueueManager(this.pageIndex, event);
  }

  getRights() {
    this.checkRights(this.rights.executeRight);
    this.checkRights(this.rights.globalReader);

    // se caso alterar a ordem de execução, deve-se alterar o this.isOnInit = false dentro deste método para o último método executado
    this.checkItemRight();
  }

  checkRights(right) {
    this.errorMessage = '';
    this.bpService.checkRights(right)
      .subscribe(hasRight => {
        switch (right) {
          case this.rights.executeRight:
            this.hasExecuteRight = hasRight.length > 0;
            this.executedRight = true;
            break;
          case this.rights.globalReader:
            this.hasGlobalReader = hasRight.length > 0;
            this.executedGlobalReader = true;
            break;
        }
      }, error1 => this.errorMessage = error1);
  }

  checkItemRight() {
    this.errorMessage = '';
    this.adminService.checkItemsRight(this.menuItem).subscribe(hasRight => {
      this.isMenuEnabled = hasRight;

      if (this.executedRight && this.executedGlobalReader) {
        this.isOnInit = false;
      }
    }, error1 => this.errorMessage = error1);
  }

  getDefaultFilter() {
    return {
      businessProcessId: null,
      columns: [],
      columnsComparisonType: 1,
      finalDate: null,
      initialDate: null,
      lockedInstances: false,
      pageIndex: this.pageIndex,
      stateId: null,
      userLogon: null
    }
  }

  getPleaseWaitRet(pleaseWait) {
    this.pleaseWait = pleaseWait;
  }

  getPagedQueueManager(page: number, filter = null, isCustom = false) {

    if (filter == null) {
      if (!isCustom) {
        filter = this.getDefaultFilter();
      } else {
        filter = this.lastCustomFilter;
      }
    }
    filter.pageIndex = this.pageIndex = page;

    if (!isCustom) {
      this.loadingList = true;
      if (filter == null) {
        filter = this.getDefaultFilter();
      }

      filter.stateLifeCycles = [ StateLifeCycle.lockedForHumanInteraction, StateLifeCycle.waitingForHumanInteraction, StateLifeCycle.interacting ];
      if (filter.lockedInstances && filter.userLogon == null) {
        filter.stateLifeCycles = [ StateLifeCycle.lockedForHumanInteraction ];
      }

      this.filterQueue = filter;

      this.bpQueueManagerList = [];

      this.errorMessage = '';
      this.bpAdmin.searchQueueManager(filter)
        .pipe(tap( res => {
            this.getPaginationConfig(page, res['total']);
          })
        )
        .subscribe(result => {
          this.bpQueueManagerList = result['interactionQueueItems'];
          this.getRegularUserAllocation();
          this.loadingList = false;
        }, error1 => this.errorMessage = error1);
    } else {
      this.loadingCustomList = true;
      this.customSearch = true;
      filter.pageSize = this.pageConfig.pageSize;

      this.resultSearchCustomQueueConfig = [];
      this.humanInteractionService.getPagedInteractionQueueItems(filter).pipe(tap( res => {
          this.getPaginationConfig(page, res['total']);
        })
      ).subscribe(result => {
        this.resultSearchCustomQueueConfig = this.getCustomQueueResultRows(result['interactionQueueItems']);
        this.loadingCustomList = false;
      }, error1 => this.errorMessage = error1);
      this.lastCustomFilter = filter;
    }

  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.errorMessage = '';
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'server',
        itemsPerPage: item,
        currentPage: _currentPage,
        totalItems: _totalItems
      };
    }, error1 => this.errorMessage = error1);
  }

  getPageConfig() {
    this.errorMessage = '';
    this.webClientConfig.getPageConfig()
      .subscribe(pageConfig => {
          this.pageConfig = pageConfig;
        },
        error1 => {
          this.errorMessage = error1;
        });
  }

  getTimeInQueue(date) {
    let dateNow = new Date();
    return DateTimeService.dateDiff(dateNow, date);
  }

  getRegularUserAllocation() {
    let currentUsers: { userLogon: string, userDetails: any}[] = [];
    for (let i = 0; i < this.bpQueueManagerList.length; i++) {
      let item = this.bpQueueManagerList[i];
      if (item.stateLifeCycle == StateLifeCycle.lockedForHumanInteraction ||
        item.stateLifeCycle == StateLifeCycle.interacting) {

        let user = currentUsers.find(f => f.userLogon == item.modifiedBy);
        if (user == undefined) {
          this.getUserByLogon(item.modifiedBy, currentUsers, i);
        } else {
          this.bpQueueManagerList[i].labelUserName = user[0].logon;
          this.bpQueueManagerList[i].tooltipUserName = `${user[0].firstName} ${user[0].lastName}`;
        }
      }
    }
  }

  getUserByLogon(user, currentUsers, index) {
    this.errorMessage = '';
    this.adminService.getUserByLogonName(user).subscribe(result => {
      currentUsers.push(user, result);
      this.bpQueueManagerList[index].labelUserName = result['logon'];
      this.bpQueueManagerList[index].tooltipUserName = `${result['firstName']} ${result['lastName']}`;
    }, error1 => this.errorMessage = error1 );
  }

  getCustomQueueConfig() {
    this.errorMessage = '';
    this.humanInteractionService.getCustomInteractionQueueConfig().subscribe(result => {
      this.customQueueConfigList = result;
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getCustomQueueResultRows(rows) {
    rows.forEach(f => {
      let customInteractionQueueName = '';

      if (this.customQueueConfigList && this.customQueueConfigList.length > 0) {
        customInteractionQueueName = this.customQueueConfigList
          .filter(custom => custom.id === f.customInteractionQueueConfigId).map(m => m.name)[0];
      } else {
        throw new Error('Não existe fila nomeada cadastrada!');
      }

      const date1 = new Date(this.dateTimeService.toLocalISOStringDateTime(f.stateModifyDate, false));
      const date2 = new Date();

      let diff = date2.getTime() - date1.getTime();

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      diff -= days * (1000 * 60 * 60 * 24);

      const hours = Math.floor(diff / (1000 * 60 * 60));
      diff -= hours * (1000 * 60 * 60);

      const mins = Math.floor(diff / (1000 * 60));
      diff -= mins * (1000 * 60);

      const seconds = Math.floor(diff / (1000));
      diff -= seconds * (1000);

      const sla = days + ' dia(s), ' + hours + ' hora(s), ' + mins + ' min, ' + seconds + ' seg';

      let lockedTo = '';
      if (f.stateLifeCycle == 8 || f.stateLifeCycle == 11) {
        lockedTo = f.modifiedBy;
      }

      f.creationDate = this.dateTimeService.toLocalStringDateTime(f.creationDate, false);
      f.stateModifyDate = this.dateTimeService.toLocalStringDateTime(f.stateModifyDate, false);
      f.customInteractionQueueName = customInteractionQueueName;
      f.lockedTo = lockedTo;
      f.sla = sla;
    });

    return rows;
  }

  selectAll(element, className = 'checkbox-selection', isCustom = false) {
    const selectAllChecked = element.target.checked;
    if (!isCustom) {
      this.disableRegularAllocationBtn = !selectAllChecked;
    } else {
      this.disableCustomAllocationBtn = !selectAllChecked;
    }

    const aCheckBox = document.getElementsByClassName(className);
    for (let i = 0; i < aCheckBox.length; i++) {
      const item = <HTMLInputElement>document.getElementById(aCheckBox[i].id);
      item.checked = selectAllChecked;
    }
  }

  chkActions(className = 'checkbox-selection', isCustom = false) {
    const aCheckBox = document.getElementsByClassName(className);
    this.disableBtnQueueAction(aCheckBox, isCustom);
    this.checkSelectAll(aCheckBox, isCustom);
  }

  checkSelectAll(chkList, isCustom) {
    let total = chkList.length;
    let totalChecked = this.getTotalChecked(chkList);
    let resultChecked = total - totalChecked.length;

    const chkSelectAll = <HTMLInputElement>document.getElementById(`checkbox-selectAll${isCustom?'-custom':''}`);
    chkSelectAll.checked = resultChecked == 0;
  }

  getTotalChecked(chkList) {
    return Array.prototype.slice.call(chkList).filter(f => f.checked);
  }

  disableBtnQueueAction(aCheckBox, isCustom) {
    let totalChecked = this.getTotalChecked(aCheckBox);
    if (!isCustom) {
      this.disableRegularAllocationBtn = totalChecked.length == 0;
    } else {
      this.disableCustomAllocationBtn = totalChecked.length == 0;
    }
  }

  openQueueActionModal(className = 'checkbox-selection', isCustom = false) {
    let canOpenModal = true;
    const aCheckBox = document.getElementsByClassName(className);
    const totalChecked = this.getTotalChecked(aCheckBox);
    let params: any = {
      isCustom: isCustom,
      checkedInstances: totalChecked.map(m => parseFloat(m.value)),
      checkedInstancesStatesId: (totalChecked.map(m => m.dataset))
        .map(mm => mm.stateId).filter((value, index, self) => self.indexOf(value) === index)
    };

    if (isCustom) {
      this.customErrorMessage = '';
      params.customQueues = (totalChecked.map(m => m.dataset))
        .map(mm => mm.customQueueId).filter((value, index, self) => self.indexOf(value) === index);
      const selectedInstances = this.resultSearchCustomQueueConfig.filter(f => params.checkedInstances.indexOf(f.businessProcessInstanceId) != -1);

      canOpenModal = this.validateCustomCheckedInstances(params.checkedInstances);
    }

    if (canOpenModal) {
      const destComponent: any = QueueActionModalComponent;
      const result$ = this.modalService.showObjModal(destComponent, 'Definir alocação', params, 'modal-md');
      result$.asObservable()
        .subscribe(
          result => {
            if (result) {
              if (!isCustom) {
                this.getPagedQueueManager(this.pageIndex, this.filterQueue, false);
              } else {
                this.customAfterClosingModal();
              }
            }
          }
        );
    }
  }

  openQueueShiftModal() {

    const aCheckBox = document.getElementsByClassName('checkbox-selection-custom');
    const totalChecked = this.getTotalChecked(aCheckBox);
    let params: any = {
      checkedInstances: totalChecked.map(m => parseFloat(m.value)),
      interactionQueuesToShift: []
    };
    const selectedInstances = this.getSelectedInstances(params.checkedInstances);
    let businessProcessId = selectedInstances[0].businessProcessId;
    let stateId = selectedInstances[0].stateId;

    params.interactionQueuesToShift = this.customQueueConfigList
      .filter(f => (f.stateId == stateId && f.businessProcessId == businessProcessId) ||
        (f.stateId == 0 && f.businessProcessId == businessProcessId));
    let canOpenModal = this.validateCustomCheckedInstances(params.checkedInstances, true);

    if (canOpenModal) {
      const destComponent: any = QueueShiftModalComponent;
      const result$ = this.modalService.showObjModal(destComponent, 'Definir fila', params, 'modal-md');
      result$.asObservable()
        .subscribe(
          result => {
            if (result) {
              this.customAfterClosingModal();
            }
          }
        );
    }
  }

  validateCustomCheckedInstances(checkedInstances, isShift = false) {
    const selectedInstances = this.getSelectedInstances(checkedInstances);

    //validar se todas as instâncias selecionadas estão no mesmo estado do mesmo PN
    let equalInstances = selectedInstances
      .filter(f => f.businessProcessId == selectedInstances[0].businessProcessId &&
        f.stateId == selectedInstances[0].stateId);

    if (isShift && equalInstances) {
      equalInstances = equalInstances.filter(f => f.stateLifeCycle == 7);
    }

    if (!equalInstances || equalInstances.length != checkedInstances.length) {
      let phrase = 'para fazer a definição de alocação em lote';
      if (isShift) {
        phrase = 'e aguardando interação humana para fazer a transferência de fila em lote';
      }
      this.customErrorMessage = `As instâncias precisam estar no mesmo estado do processo de negócio ${phrase}`;
      setTimeout(() => {
        this.customErrorMessage = '';
      }, 7000);
      return false;
    }
    return true;
  }

  getSelectedInstances(checkedInstances) {
    return this.resultSearchCustomQueueConfig.filter(f => checkedInstances.indexOf(f.businessProcessInstanceId) != -1);
  }

  customAfterClosingModal() {
    this.disableCustomAllocationBtn = true;
    this.getPagedQueueManager(this.pageIndex, null, true);
  }

}
